import { render } from "./EditorImage.vue?vue&type=template&id=1e89e32a&scoped=true"
import script from "./EditorImage.vue?vue&type=script&lang=ts"
export * from "./EditorImage.vue?vue&type=script&lang=ts"

import "./EditorImage.vue?vue&type=style&index=0&id=1e89e32a&lang=scss"
import "./EditorImage.vue?vue&type=style&index=1&id=1e89e32a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e89e32a"

export default script